{
  "actions": "Akce",
  "actionsAvailable": "Dostupné akce.",
  "clearSelection": "Vymazat výběr",
  "selected": "Vybráno: { count }",
  "selectedAll": "Vybráno vše"
}
